module.exports = "<template> <price-set-input-new value.two-way=field.value field.bind=field></price-set-input-new> </template> ";